import { GridLegacy as Grid } from '@mui/material'; //Grid2 is now recommended and has replaced Grid. GridLegacy is the original component.
import { HistoryRegular } from 'emerald-icons/dist/HistoryRegular';
import {
    DataCard, VisuallyHidden, WidgetTable, WidgetTable_Body, WidgetTable_Head, WidgetTable_Header,
    WidgetTable_Row,
    DataCard_EmptyState
} from 'emerald-ui';
import React from 'react';
import {
    TravelHistory_Root
} from './TravelHistory.style';
import { TravelHistoryRow } from './TravelHistoryRow';

/**
 * @typedef ShipmentUpdateStatus An entry in the history of status updates for a shipment or cargo.
 * @property {string} icon
 * @property {string} location
 * @property {string} timestamp
 * @property {string} status
 */

/**
 * @typedef TravelHistoryProps
 * @property {ShipmentUpdateStatus[]} data
 */

/** @type {(props: TravelHistoryProps & React.HTMLAttributes<HTMLDivElement>) => JSX.Element} */
export const TravelHistory = (props) => {
    const {
        data = [],
        ...otherProps
    } = props;

    const rows = data.map((dataRow) => {
        return (
            <TravelHistoryRow dataRow={dataRow} key={dataRow.timestamp} />
        );
    });

    let content;
    if (data.length) {
        content = (
            <WidgetTable>
                <WidgetTable_Head>
                    <WidgetTable_Row>
                        <VisuallyHidden as={WidgetTable_Header}>Type</VisuallyHidden>
                        <VisuallyHidden as={WidgetTable_Header}>Location</VisuallyHidden>
                        <VisuallyHidden as={WidgetTable_Header}>Time</VisuallyHidden>
                        <VisuallyHidden as={WidgetTable_Header}>Date</VisuallyHidden>
                    </WidgetTable_Row>
                </WidgetTable_Head>
                <WidgetTable_Body>
                    {rows}
                </WidgetTable_Body>
            </WidgetTable>
        );
    } else {
        content = <DataCard_EmptyState />;
    }

    return (
        <DataCard
            headerText='Travel History'
            icon={<HistoryRegular />}
            {...otherProps}
        >
            <Grid
                component={TravelHistory_Root}
                item
                xs={12}
            >
                {content}
            </Grid>
        </DataCard>
    );
};
